import { render, staticRenderFns } from "./InventoryDocumentUpload.vue?vue&type=template&id=6b3cf8b4&"
import script from "./InventoryDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./InventoryDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports